export const RESPAWN_COOLDOWN_MS = 30_000;

/**
 * Whether to surface the tick's active spawn. A claimed spawn is suppressed
 * forever; an auto-despawned (un-tapped) one is suppressed only until its
 * cooldown elapses, then a later tick re-shows it while it's still active
 * server-side.
 */
export function shouldShowSpawn(args: {
  tickSpawnId: string | null;
  shownSpawnId: string | null;
  claimed: ReadonlySet<string>;
  cooldownUntil: number;
  now: number;
}): boolean {
  const { tickSpawnId, shownSpawnId, claimed, cooldownUntil, now } = args;
  if (!tickSpawnId || shownSpawnId) return false;
  if (claimed.has(tickSpawnId)) return false;
  if (now < cooldownUntil) return false;
  return true;
}
